import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { TimepickerComponent } from '@shared/timepicker/components/timepicker.component';

@NgModule({
  declarations: [TimepickerComponent],
  imports: [ CommonModule, TranslocoModule ],
  exports: [TimepickerComponent],
  providers: [],
})
export class TimepickerModule {}
